<script setup lang="ts">
import ExerciseMCQ from "~/features/computer/components/ExerciseMCQ.vue";
import { moduleMistakes, modulesQuizQuestions } from "~/features/python/ch2/modules/data/modules.content";
</script>

<template>
  <section class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Common Mistakes</h2>
      <ul class="mt-3 space-y-2 text-sm text-slate-700">
        <li v-for="mistake in moduleMistakes" :key="mistake">{{ mistake }}</li>
      </ul>
    </div>

    <div class="space-y-4 pt-2">
      <div>
        <h2 class="text-lg font-semibold text-slate-900">Quick Quiz</h2>
        <p class="mt-1 text-sm text-slate-600">Import syntax aur module/package difference ko test karo.</p>
      </div>

      <ExerciseMCQ
        v-for="question in modulesQuizQuestions"
        :key="question.id"
        :question="question"
      />
    </div>
  </section>
</template>
